import React from 'react';

interface SignalStrengthBarProps {
  percentage: number;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const SignalStrengthBar: React.FC<SignalStrengthBarProps> = ({ 
  percentage, 
  showLabel = true,
  size = 'md'
}) => {
  const getColorClass = () => {
    if (percentage >= 70) return 'bg-status-success';
    if (percentage >= 40) return 'bg-status-warning';
    return 'bg-status-error';
  };

  const getQualityLabel = () => {
    if (percentage >= 70) return 'Excellent';
    if (percentage >= 40) return 'Good';
    return 'Poor';
  };

  const heightClasses = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3'
  };

  return (
    <div className="w-full">
      <div className={`w-full bg-muted rounded-full overflow-hidden ${heightClasses[size]}`}>
        <div
          className={`${heightClasses[size]} ${getColorClass()} transition-all duration-300 ease-in-out rounded-full`}
          style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
        />
      </div>
      {showLabel && (
        <div className="flex justify-between items-center mt-1 text-xs text-muted-foreground">
          <span>{getQualityLabel()}</span>
          <span className="font-semibold">{percentage}%</span>
        </div>
      )}
    </div>
  );
};

